import {create} from 'zustand';
import {getCommunes, getDistrict, getProvince} from "../network/api";
import {localGetItem} from "../utils/localStorage";

const locationStore = create((set) => ({
    provinces: [],
    districts: [],
    communes: [],
    setProvinces: (province) => set({province}),
    setDistricts: (district) => set({district}),
    setCommunes: (commune) => set({commune}),
    getProvinces: async () => {
        const localData = localGetItem('provinces');
        if (!localData || !localData?.length) {
            const response = await getProvince();
            if (response?.success) {
                const provinces = response.success
                    ? response.data?.data?.items.map((province) => ({
                        ...province,
                        id: province.name
                    }))
                    : null;
                set({provinces});
                localStorage.setItem('provinces', JSON.stringify(provinces));
            }
        } else {
            set({provinces: localData});
        }
    },
    getDistricts: async ({provinceId}) => {
        const response = await getDistrict({provinceId});
        if (response.success) {
            const districts = response.success
                ? response.data?.data?.items.map((district) => ({
                    ...district,
                    id: district.name
                }))
                : null;
            set({districts});
        }
    },
    getCommunes: async ({districtId}) => {
        const response = await getCommunes({districtId});
        if (response.success) {
            const communes = response.success
                ? response.data?.data?.items.map((commune) => ({
                    ...commune,
                    id: commune.name
                }))
                : null;
            set({communes});
        }
    }
}));

export default locationStore;